import { createSelector } from 'reselect'
import { pendingSelector } from 'api/selectors'
import * as auth from '../auth'

const stateSelector = state => state.creditCards

export const creditCardsSelector = createSelector(auth.selectors.userSelector, user => (user ? user.creditCards : []))

export const creditCardFormStateSelector = state => state.creditCards

export const creditCardSuccessfullyAddedSelector = state => state.creditCards?.creditCard?.cardIsSuccessfullyAdded

export const creditCardAddFailedErrorSelector = state => state.creditCards?.creditCard?.addCreditCardFailedError

export const creditCardPendingSelector = createSelector(pendingSelector, pending => pending.creditCard)

export const pseBanksSelector = createSelector(stateSelector, state => {
    const { psePaymentBanks } = state

    if (psePaymentBanks) {
        return psePaymentBanks.map(psePaymentBank => ({
            label: psePaymentBank.bankName,
            value: psePaymentBank.bankCode,
        }))
    }
    return null
})

export const pixQrCodeDataSelector = createSelector(stateSelector, state => state.pixQrCodeData)
